import API from '@/api/index';

const device = {
  state: {
    devices: [],
    totalDevice: 0
  },

  mutations: {
    SET_DEVICES: (state, devices) => {
      state.devices = devices;
    },
    SET_TOTAL_DEVICES: (state, totalDevice) => {
      state.totalDevice = totalDevice;
    },
    UPDATE_DEVICE_PLAN_CODE: (state, devices) => {
      devices.map(d => {
        let device = state.devices.filter(a => a.imei === d.imei.trim())[0];
        if (device) {
          let index = state.devices.indexOf(device);
          if (index > 0) {
            state.devices[index].planCode = d.planCode;
          }
        }
        return 0;
      });
    }
  },

  actions: {
    getDevices ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.device
          .getDevices(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let devices = result.data.data;
              commit('SET_DEVICES', devices);
              commit('SET_TOTAL_DEVICES', result.data.totalRecords);
              resolve(devices);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getDeviceByImei: ({ state }, imei) => {
      return state.devices.find(a => a.imei === imei); 
    },
    importDevices ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .importDevices(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let sims = result.data;
              resolve(sims);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    moveDevices ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .moveDevices(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    returnDevices ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .returnDevices(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changePlanCode ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .changePlanCode(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    sendCommand ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .sendCommand(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getCommand ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.device
          .getCommand(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getPackets ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.device
          .getPackets(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    renew ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .renew(data)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    updateLastWaypoint ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.device
          .updateLastWaypoint(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default device;



// WEBPACK FOOTER //
// ./src/store/modules/device.js